import { render, staticRenderFns } from "./SelectionPane.vue?vue&type=template&id=172a1ea2&"
import script from "./SelectionPane.vue?vue&type=script&lang=ts&"
export * from "./SelectionPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports